import { IconDualToneType } from './type';

const IconNext = ({
  width = 31,
  height = 31,
  fill = '#424244',
  secondFill = 'white',
}: IconDualToneType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99999 30.7405H20.74C26.2628 30.7405 30.74 26.2633 30.74 20.7405V10.0005C30.74 4.47763 26.2628 0.000480577 20.74 0.000480577H9.99999C4.47714 0.000480577 -7.7045e-06 4.47763 -7.7045e-06 10.0005V20.7405C-7.7045e-06 26.2633 4.47714 30.7405 9.99999 30.7405Z"
        fill={secondFill}
      />
      <path
        d="M12.85 6.58052L20.39 14.1205C20.6538 14.3865 20.8018 14.7459 20.8018 15.1205C20.8018 15.4951 20.6538 15.8546 20.39 16.1205L12.39 24.1205C12.124 24.3843 11.7646 24.5323 11.39 24.5323C11.0154 24.5323 10.6559 24.3843 10.39 24.1205V24.1205C10.1262 23.8546 9.97815 23.4951 9.97815 23.1205C9.97815 22.7459 10.1262 22.3865 10.39 22.1205L16.39 16.1205C16.6491 15.8521 16.7938 15.4936 16.7938 15.1205C16.7938 14.7475 16.6491 14.3889 16.39 14.1205L10.87 8.61052C10.6109 8.34208 10.4661 7.98358 10.4661 7.61052C10.4661 7.23745 10.6109 6.87895 10.87 6.61052V6.61052C11.1336 6.35324 11.4857 6.20674 11.854 6.20116C12.2223 6.19558 12.5787 6.33134 12.85 6.58052V6.58052Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconNext;
